import { SimpleSlider } from '@/app/components/shared/form/slider/SimpleSlider';
import { useFormContext } from '../../../contexts/formContext';
import { OptionalSetting } from '../../../components/OptionalSetting';

const marks = [
  { value: 1, label: '1' },
  { value: 10, label: 'AR' },
  { value: 20, label: 'VR' },
  { value: 25, label: '25' },
];

export function MegabytesSetting() {
  const form = useFormContext();
  const isSettingEnabled = Boolean(form.getValues().limits?.megabyte !== undefined);

  const onEnableChange = (enabled: boolean) => {
    if (enabled) {
      form.setValues((prev) => ({
        limits: {
          ...prev.limits,
          megabyte: 0,
        },
      }));
    } else {
      form.setFieldValue('limits.megabyte', undefined);
    }
  };

  return (
    <OptionalSetting isEnabled={isSettingEnabled} onChanged={onEnableChange} title='MB limit'>
      <SimpleSlider
        labelAlwaysOn={true}
        min={0}
        max={25}
        step={0.1}
        marks={marks}
        w={400}
        {...form.getInputProps('limits.megabyte')}
      />
    </OptionalSetting>
  );
}
